import React, { useEffect, useState } from "react";
import { useAvailabilityContext } from "./context/AvailabilityContext";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"
import { useUncheckCommunity } from "Api/Coordinator/Gebruikers";

const UncheckConfirmModal = ({ iAdminId }) => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const {
        showUncheckModal,
        setShowUncheckModal,
        setType,
        communityToUncheck
    } = useAvailabilityContext();

    const { data } = useUncheckCommunity(
        communityToUncheck?.id,
        "S",
        iAdminId,
        shouldFetch
    );


    const handleUncheckCommunity = () => {
        setShouldFetch(true);
    };

    useEffect(() => {
        if (!data) return;

        if (data.status === "success") {
            setType(communityToUncheck.id + "S");
        }

        setShowUncheckModal(false);
        setShouldFetch(false);
    }, [data]);


    return (
        <Modal
            isOpen={showUncheckModal}
            toggle={() => {
                setShowUncheckModal(false);
            }}
            className="modal-centered contract-type-modal feedback-modal-style link-form"
        >
            <ModalHeader toggle={() => setShowUncheckModal(false)}>
                Wijzigen beschikbaarheid?
            </ModalHeader>
            <ModalBody className="text-center mt-4 mb-4">
                <p>
                    Beschikbaarheid {communityToUncheck.name}  naar standaard - beschikbaarheid wijzigen?
                </p>
                <p>
                    Hierdoor wordt de bestuursbeschikbaarheid van  {communityToUncheck.name}  verwijderd.
                </p>
            </ModalBody>
            <ModalFooter className="justify-content-center pt-3">
                <Button color="link" onClick={handleUncheckCommunity} className="btn-color-style">
                    Ja
                </Button>
                <Button
                    color="link"
                    onClick={() => {
                        setShowUncheckModal(false);
                    }}
                    className="btn-color-style"
                >
                    Nee
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default UncheckConfirmModal;
